export const SPACING = {
  xs: 0.5,
  sm: 1,
  md: 2,
  lg: 4,
  xl: 6,
  xxl: 10,
} as const
